module.exports = __webpack_public_path__ + "media/images/_eyecatch-inquiry-c3b7480d1eb56c9a522b2c920b304df1.svg";